import apiClient from '../axios.js';

/**
 * 服務條款管理 API
 */
export const termsService = {
  /**
   * 獲取服務條款列表
   * @param {Object} params - 查詢參數
   * @param {number} params.page - 頁碼
   * @param {number} params.pageSize - 每頁數量
   * @param {string} params.search - 搜尋關鍵字
   * @param {string} params.status - 狀態 (draft, published, archived)
   * @param {string} params.language - 語言代碼
   * @param {string} params.sortBy - 排序欄位
   * @param {string} params.order - 排序方向
   * @returns {Promise<Object>} 服務條款列表
   */
  getTerms: async (params = {}) => {
    const response = await apiClient.get('/terms', { params });
    return response;
  },

  /**
   * 獲取當前生效的服務條款
   * @param {string} language - 語言代碼（選填，預設 'zh-TW'）
   * @returns {Promise<Object>} 當前生效的服務條款
   */
  getCurrent: async (language = 'zh-TW') => {
    const response = await apiClient.get('/terms/current', {
      params: { language }
    });
    return response;
  },

  /**
   * 獲取單一服務條款詳情
   * @param {string} id - 服務條款 ID
   * @returns {Promise<Object>} 服務條款詳情
   */
  getTerm: async (id) => {
    const response = await apiClient.get(`/terms/${id}`);
    return response;
  },

  /**
   * 新增服務條款
   * @param {Object} termsData - 服務條款資料
   * @param {string} termsData.version - 版本號
   * @param {string} termsData.title - 標題
   * @param {string} termsData.content - 內容
   * @param {string} termsData.language - 語言代碼（選填，預設 'zh-TW'）
   * @param {string} termsData.status - 狀態（選填，預設 'draft'）
   * @param {string} termsData.effectiveDate - 生效日期 (YYYY-MM-DD)
   * @returns {Promise<Object>} 新增結果
   */
  createTerm: async (termsData) => {
    const response = await apiClient.post('/terms', termsData);
    return response;
  },

  /**
   * 更新服務條款
   * @param {string} id - 服務條款 ID
   * @param {Object} termsData - 服務條款資料
   * @returns {Promise<Object>} 更新結果
   */
  updateTerm: async (id, termsData) => {
    const response = await apiClient.put(`/terms/${id}`, termsData);
    return response;
  },

  /**
   * 發布服務條款
   * @param {string} id - 服務條款 ID
   * @returns {Promise<Object>} 發布結果
   */
  publishTerm: async (id) => {
    const response = await apiClient.post(`/terms/${id}/publish`);
    return response;
  },

  /**
   * 刪除服務條款
   * @param {string} id - 服務條款 ID
   * @returns {Promise<Object>} 刪除結果
   */
  deleteTerm: async (id) => {
    const response = await apiClient.delete(`/terms/${id}`);
    return response;
  },
};
